import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Select from 'react-select';
import * as Yup from 'yup';
import { Table } from "antd";
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import { useNavigate, Link } from 'react-router-dom'
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const closeButtonRef = useRef(null);
    const ApplicableOption = [{ value: 'Non-Hazardous', label: 'Non-Hazardous' },
    { value: 'Hazardous', label: 'Hazardous' },
    { value: 'Perishable', label: 'Perishable' },]
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        SCAC: Yup.string().required('SCAC is required'),
        Alias: Yup.string().required('Alias is required'),
        AccountNo: Yup.string().required('Account No is required'),
        HomePageUrl: Yup.string().required('HomePage Url is required'),
        TrackingUrl: Yup.string().required('Tracking Url is required'),
        BlFormat: Yup.string().required('BL Format is required'),
        NVOCC: Yup.boolean().oneOf([true], 'NVOCC must be checked')
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type
            SCAC: "",
            Alias: "",
            AccountNo: "",
            HomePageUrl: "",
            TrackingUrl: "",
            applicableFor: '',
            BlFormat: "",
            NVOCC: false
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });

    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Shipping Line</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.name}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="error">{formik.errors.name}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-2 ">

                                <div className=" mb-1 d-flex justify-content-between align-items-center">
                                    <label htmlFor="name" className="form-label mb-0 ">
                                        SCAC
                                    </label>
                                    <div className="mb-0 form-check">
                                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                        <label className="form-label mb-0" htmlFor="exampleCheck1">
                                            NVOCC
                                        </label>
                                    </div>
                                </div>


                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="SCAC"
                                        name="SCAC"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.SCAC}
                                    />
                                    {formik.touched.SCAC && formik.errors.SCAC ? (
                                        <div className="error">{formik.errors.SCAC}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Alias <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="Alias"
                                        name="Alias"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Alias}
                                    />
                                    {formik.touched.Alias && formik.errors.Alias ? (
                                        <div className="error">{formik.errors.Alias}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Account No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="AccountNo"
                                        name="AccountNo"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.AccountNo}
                                    />
                                    {formik.touched.AccountNo && formik.errors.AccountNo ? (
                                        <div className="error">{formik.errors.AccountNo}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Home Page URL <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="HomePageUrl"
                                        name="HomePageUrl"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.HomePageUrl}
                                    />
                                    {formik.touched.HomePageUrl && formik.errors.HomePageUrl ? (
                                        <div className="error">{formik.errors.HomePageUrl}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Trancking URL <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="TrackingUrl"
                                        name="TrackingUrl"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.TrackingUrl}
                                    />
                                    {formik.touched.TrackingUrl && formik.errors.TrackingUrl ? (
                                        <div className="error">{formik.errors.TrackingUrl}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    BL Format <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="BlFormat"
                                        name="BlFormat"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.BlFormat}
                                    />
                                    {formik.touched.BlFormat && formik.errors.BlFormat ? (
                                        <div className="error">{formik.errors.BlFormat}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" >
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit" >
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit" >
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Close
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster